import { State } from './interfaces'

export const INITIAL_STATE: State = {
  breed: '-1',
  breeds: [],
  dogs: [],
  loading: false,
  error: null
}
